import BaseService from 'services/BaseService';
import api from '../common/constants/api';

class DocumentationService extends BaseService {
  getLinks() {
    return this.get(api.documents).then(documents => {
        return documents.map(document => {
            return {
                text: document.Text,
                href: document.Href
            };
        })
    });
  }
}

export default DocumentationService;



// WEBPACK FOOTER //
// ./src/services/DocumentationService.js